import { Component, Input, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SubstitutionConditionDto, TacticChangeDto } from "app/models";
import { NotificationService } from "app/services";
import { CONSTANTS } from '../../../constants';

@Component({
    selector: 'edit-tactic-change-modal',
    templateUrl: './edit-tactic-change.modal.html',
    styleUrls: ['./edit-tactic-change.modal.scss'],
})
export class EditTacticChangeModal implements OnInit {
    @Input() change: TacticChangeDto;

    
    minutesLookup: number[];
    scoresLookup: number[];
    tactics: number[];

    const;

    constructor(public activeModal: NgbActiveModal, private notificationService: NotificationService) {
        this.const = CONSTANTS;
    }

    ngOnInit(): void {
        this.buildLookups();
    }

    getMinuteLabel() {
        if (!this.change.minute)
            return null;

        return this.change.minute.value;
    }

    selectMinute(val: number) {
        this.change.minute.value = val;
    }

    isMinuteSectionVisible(): boolean {
        if (!this.change.minute)
            return false;

        return true;
    }

    toggleMinuteSection() {
        if (this.change.minute)
            this.change.minute = null;
        else {
            this.change.minute = new SubstitutionConditionDto();
            this.change.minute.value = 0;
            this.change.minute.condition = CONSTANTS.substitutionConditions.more;
        }
    }

    isMinuteLessConditionSelected(): boolean {
        if (!this.change.minute)
            return false;
        
        return this.change.minute.condition === CONSTANTS.substitutionConditions.less;
    }

    isMinuteGreaterConditionSelected(): boolean {
        if (!this.change.minute)
            return false;
        
        return this.change.minute.condition === CONSTANTS.substitutionConditions.more;
    }

    changeMinuteCondition(val: number) {
        this.change.minute.condition = val;
    }

    getScoreLabel() {
        if (!this.change.score)
            return null;

        return this.change.score.value;
    }

    selectScore(val: number) {
        this.change.score.value = val;
    }

    isScoreSectionVisible(): boolean {
        if (!this.change.score)
            return false;

        return true;
    }

    toggleScoreSection() {
        if (this.change.score)
            this.change.score = null;
        else {
            this.change.score = new SubstitutionConditionDto();
            this.change.score.value = 0;
            this.change.score.condition = CONSTANTS.substitutionConditions.more;
        }
    }

    isScoreLessConditionSelected(): boolean {
        if (!this.change.score)
            return false;
        
        return this.change.score.condition === CONSTANTS.substitutionConditions.less;
    }

    isScoreGreaterConditionSelected(): boolean {
        if (!this.change.score)
            return false;
        
        return this.change.score.condition === CONSTANTS.substitutionConditions.more;
    }

    isScoreEqualConditionSelected(): boolean {
        if (!this.change.score)
            return false;
        
        return this.change.score.condition === CONSTANTS.substitutionConditions.equal;
    }

    changeScoreCondition(val: number) {
        this.change.score.condition = val;
    }

    onSubmit() {
        if (this.isModelValid()) {
            this.activeModal.close(this.change);
        }
    }

    isModelValid(): boolean {
        if (!this.change.tactic) {
            return false;
        }

        if (!this.change.minute && !this.change.score) {
            return false;
        }

        return true;
    }

    getTacticLabel() {
        if (!this.change.tactic)
            return null;
        
        return "Тактика-"+ this.change.tactic;
    }

    selectTactic(val: number) {
        this.change.tactic = val;

    }

    toggleChangePosition() {
        this.change.isChangePosition = !this.change.isChangePosition;
    }

    toggleChangeSettings() {
        this.change.isChangeSettings = !this.change.isChangeSettings;
    }

    private buildLookups() {
        this.minutesLookup = [];
        for (let i = 0; i < 24; i++) {
            this.minutesLookup.push(i * 5);
        }

        this.scoresLookup = [];
        for (let i = -5; i < 6; i++) {
            this.scoresLookup.push(i);
        }

        this.tactics = [];
        for (let i=1; i<8; i++) {
            this.tactics.push(i);
        }
    }
}